import {Component, h, State, Element, Event, EventEmitter, Method, Listen, getAssetPath} from '@stencil/core';
import { i18n, translateCountryName } from '../../utils/I18n';
import { NjDialog } from '../nj-dialog/nj-dialog';
import { SelectedUser } from '../nj-passangers/nj-passangers';
import { ReductionCardsApi } from './ReductionCardsApi';

@Component({
    tag: 'nj-reduction-cards',
    styleUrl: 'nj-reduction-cards.css',
})
export class NjReductionCards {
    rawData: any;
    cardData: any[];
    dialogEl: NjDialog;
    filteredCountries: string[];
    searchMode: boolean = false;

    flagName: any = {
        'Österreich': 'at.gif',
        'Deutschland': 'de.gif',
        'Italien': 'it.gif',
        'Schweiz': 'ch.gif',
        'Slowakei': 'sk.gif',
        'International': 'int.gif',
        'Dänemark': 'dk.gif',
        'Kroatien': 'hr.gif',
        'Slowenien': 'si.gif',
        'Tschechien': 'cz.gif',
        'Ungarn': 'hu.gif'
    }

    @Element() el: HTMLElement;

    @State() renderData: any[];
    @State() selectedCards: any[] = [];
    @State() tempCards: any[] = [];
    @State() user: SelectedUser;
    @State() filterValue: string = '';

    @Event() passengerOptionsChanged: EventEmitter;

    componentWillLoad() {
        var self = this;

        this.rawData = ReductionCardsApi.getData();

        let allCountries = this.rawData.map((card) => {
            return card.Land
        })

        this.filteredCountries = allCountries.filter((value, i) => allCountries.indexOf(value) == i)

        self.cardData = this.groupReductionCards(this.rawData);
        self.renderData = [...self.cardData];
    }

    componentDidLoad() {
        this.dialogEl = this.el.parentElement as any;
    }

    @Listen('okSubmitted', {target: 'document'})
    onOkSubmitted() {
        this.user.njCards = [...this.tempCards]
        this.user.cards = [...this.tempCards.map(card => {return card.reductionCards.code})]
        this.user = {...this.user}
        this.passengerOptionsChanged.emit(this.user);
    }

    @Method()
    async setUser(user: SelectedUser) {
        this.user = user;
        this.tempCards = [...this.user.njCards]
    }

    handleSearchChange(e) {
        this.filterValue = e.target.value;
        this.filterCards(e.target.value);
    }

    groupReductionCards(givenCards: any) {
        let reductionCardsSorted = [];

        for (let i = 0; i < this.filteredCountries.length; i ++) {
            reductionCardsSorted.push({
                "Land": this.filteredCountries[i],
                "reductionCards": givenCards.filter((card) => {
                                    return card.Land == this.filteredCountries[i]
                                  }).map((obj) => { return obj.reductionCards })

            })
        }

        return reductionCardsSorted
    }

    resetValue() {
        let input: HTMLInputElement = this.el.querySelector('#search') as HTMLInputElement;
        input.value = '';
        this.renderData = this.cardData
        this.searchMode = false
        input.focus();
    }

    filterCards(filterValue: string) {
        if (filterValue && filterValue.length > 0) {
            this.searchMode = true
            this.renderData = this.groupReductionCards([
                ...this.rawData.filter(
                card => card.reductionCards.cardName.de.toLowerCase().indexOf(filterValue.toLowerCase()) > -1 || card.reductionCards.cardName.de.toLowerCase().indexOf(filterValue.replace(' ', '').toLowerCase()) > -1,
                ),
            ]);
        } else {
            this.searchMode = false
            this.renderData = this.cardData
        }
    }

    selectCard(selectedCard: any) {
        let index = this.tempCards.map(tempCard => tempCard.code).indexOf(selectedCard.code);

        if (index == -1) {
            this.tempCards = [...this.tempCards, selectedCard];
        } else {
            this.tempCards.splice(index, 1);
            this.tempCards = [...this.tempCards];
        }

        this.user.njCards = [...this.tempCards]
        this.user.cards = [...this.tempCards.map(card => {return card.code})]
        this.user = {...this.user}
        this.passengerOptionsChanged.emit(this.user);

        this.dialogEl.hide();
    }

    getCheckmark(card: any) {
        return this.tempCards.map(tempCard => tempCard.code).indexOf(card.code) > -1 ? <check-icon></check-icon> : ''
    }

    toggleAccordeon(event: Event) {
        let wantedCardGroup = (event.currentTarget as HTMLButtonElement).parentElement

        if (wantedCardGroup.classList.contains('reduction-card--open')) {
            wantedCardGroup.classList.remove('reduction-card--open')
        } else {
            let openedCardGroup = this.el.querySelector('.reduction-card--open')

            if (openedCardGroup) {
                openedCardGroup.classList.remove('reduction-card--open')
            }

            wantedCardGroup.classList.add('reduction-card--open')
        }
    }

    renderCardGroup(cardGroup: any) {
        if (cardGroup.reductionCards.length <= 0) {
            return;
        }

        return (
            <li class={{
                "reduction-card": true,
                "reduction-card--open": this.searchMode
            }}>
                <button class="reduction-card__country" onClick={(event: Event) => this.toggleAccordeon(event)}>
                    <span>
                        <img src={getAssetPath(`../assets/flags/${this.flagName[cardGroup.Land]}`)} class="reduction-card__flag" aria-hidden="true" />
                        {i18n.getMessage(translateCountryName(cardGroup.Land))}
                    </span>
                    <arrow-down-icon class="icon-toggler" />
                </button>
                <ul class={{
                    'reduction-card-group': true
                }}>
                    {cardGroup.reductionCards.map(rCard => (
                        <li class="reduction-card-group__card">
                            <button class="reduction-card-group__card-button" type="button" onClick={() => this.selectCard(rCard)}>
                                <card-icon class="card-icon" />
                                {i18n.getMessage(`ts.reductionCard.name.${rCard.code}`, "", null, rCard.cardName)}
                                {this.getCheckmark(rCard) }
                            </button>
                        </li>
                    ))}
                </ul>
            </li>
        )
    }

    renderCards() {
        if (this.renderData && this.renderData.length > 0) {
            return (
                <ul class="reduction-cards">
                    {this.renderData.map((cardGroup) => (
                        this.renderCardGroup(cardGroup)
                    ))}
                </ul>
            );
        } else {
            return <p>{i18n.getMessage("reduction-cards.no-reduction-cards")}</p>;
        }
    }

    render() {
        return (
            <div>
                <h3>{i18n.getMessage("reduction-cards.header-select-discounts")}</h3>
                <div class="selected-cards__filter">
                    <div class="selected-cards__rendered-cards">
                        <div>
                            <div class="nj-input nj-input-block">
                                <label htmlFor="search">{i18n.getMessage("reduction-cards.search")} </label>
                                <input type="text" id="search" name="search" onInput={(e) => this.handleSearchChange(e)} />
                                {this.filterValue.length > 0 ?
                                    <button type="button" class="close-btn" onClick={() => this.resetValue()}>
                                        <x-circle-icon />
                                    </button>
                                : null}
                            </div>
                        </div>
                        {this.renderCards()}
                    </div>
                </div>
            </div>
        );
    }
}
